import type { Questionnaire, QuestionnaireResponse } from '@medplum/fhirtypes';
import { collectQuestionnaireAnswerFields } from './questionnaireAnswerFields';

/** Plain-text export of answered note fields for clipboard recovery. */
export function formatNoteTextForCopy(
  questionnaire: Questionnaire,
  response: QuestionnaireResponse,
): string {
  const fields = collectQuestionnaireAnswerFields(questionnaire, response);
  if (fields.length === 0) return '';

  return fields
    .map((field) => `${field.label}\n${field.text}`)
    .join('\n\n');
}
